import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Constants} from '../../core/config/Constants';
import {ExtraService} from '../../core/services/extra.service';
import {ContactUsService} from '../../core/services/contact-us.service';
import {ContactUs} from '../../core/models/contact-us';

@Component({
  selector: 'app-contact-us-add',
  templateUrl: './contact-us-add.component.html',
  styleUrls: ['./contact-us-add.component.css'],
  providers: [ExtraService, ContactUsService]
})
export class ContactUsAddComponent implements OnInit {
  pageTitle: string = 'Contact Details';
  pageAlias: string = 'contact-us-form';
  disableButton = true;
  eventId: string = '';
  contactId: string = '';

  errorMessage = new Array<string>();
  isError: boolean = false;
  message: string = '';

  infoTopClass: string;
  nameClass: string;
  infoBottomClass: string;
  emailClass: string;
  phoneClass: string;
  aboutClass: string;

  classArray = new Array<string>();
  contactList: Array<ContactUs> = new Array();
  contactUs = new ContactUs();

  constructor(private contactUsService: ContactUsService, private extraService: ExtraService, private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
    this.addEmails();
    this.addPhoneNo();
    this.addAddresses();
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.queryParams.subscribe(params => {
      let id = params['eventId'];
      let contactID = params['contactId'];
      if (id) {
        this.eventId = id;
        this.extraService.setCurrentEventId(id);
        this.setContactList(id);
      }
      if (contactID) {
        this.contactId = contactID;
        this.setContactDetails(this.eventId, this.contactId);
      }
    });
  }

  setContactList(id) {
    this.message = null;
    var x = this.contactUsService.getContactList(id);
    x.snapshotChanges().subscribe(list => {
      this.contactList = new Array();
      list.forEach(element => {
        var y = element.payload.toJSON() as ContactUs;
        y['$key'] = element.key;
        this.contactList[y.position] = (y as ContactUs);
      });
    });
  }

  setContactDetails(eventId, contactId) {
    this.contactUsService.getSingleContactList(eventId, contactId).subscribe(event => {
      if (event) {
        this.contactUs = event;
        if (!this.contactUs.emails || this.contactUs.emails.length < 1) {
          this.contactUs.emails = new Array();
          this.addEmails();
        }
        if (!this.contactUs.phoneNumbers || this.contactUs.phoneNumbers.length < 1) {
          this.contactUs.phoneNumbers = new Array();
          this.addPhoneNo();
        }
        if (!this.contactUs.addresses || this.contactUs.addresses.length < 1) {
          this.contactUs.addresses = new Array();
          this.addAddresses();
        }
      }
    });
  }


  trackByIndex(index: number, value: number) {
    return index;
  }

  addEmails() {
    this.contactUs.emails.push('');
    this.classArray.push('');
  }

  removeEmails(index) {
    if (this.contactUs.emails.length > 1) {
      this.contactUs.emails = this.contactUs.emails.filter((val, i) => i != index);
      this.classArray = this.classArray.filter((val, i) => i != index);
    }
  }

  addPhoneNo() {
    this.contactUs.phoneNumbers.push('');
    this.classArray.push('');
  }

  removePhoneNumbers(index) {
    if (this.contactUs.phoneNumbers.length > 1) {
      this.contactUs.phoneNumbers = this.contactUs.phoneNumbers.filter((val, i) => i != index);
      this.classArray = this.classArray.filter((val, i) => i != index);
    }
  }

  addAddresses() {
    this.contactUs.addresses.push('');
    this.classArray.push('');
  }

  removeAddresses(index) {
    if (this.contactUs.addresses.length > 1) {
      this.contactUs.addresses = this.contactUs.addresses.filter((val, i) => i != index);
      this.classArray = this.classArray.filter((val, i) => i != index);
    }
  }

  submit() {
    this.clearClasses();
    this.message = null;
    this.isError = false;
    this.errorMessage = new Array<string>();
    this.validate();
    if (!this.contactId) {
      if (this.errorMessage.length == 0) {
        this.add();
      }
    } else {
      if (this.errorMessage.length == 0) {
        this.update();
      }
    }
  }

  validate() {
    let i;
    this.clearClasses();
    this.isError = false;
    this.errorMessage = new Array<string>();

    let emailRex = '[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}';
    //let phoneRex = "^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$"


    if (this.contactUs.name == null || this.contactUs.name.trim().length < 1) {
      this.isError = true;
      this.errorMessage.push('Name can\'t be empty');
      this.nameClass = 'form-control fieldWithErrors';
    }

    // if (this.contactUs.phoneNumbers.length > 0) {
    //   for (var i = 0; i < this.contactUs.phoneNumbers.length; i++) {
    //     if (this.contactUs.phoneNumbers[i].length == 0 && i == 0) {
    //       this.isError = true;
    //       this.errorMessage.push("Phone No. can't be empty");
    //       this.phoneClass = "form-control fieldWithErrors";
    //     }
    //   }
    // }

    if (this.contactUs.phoneNumbers.length > 0) {
      for (let i = 0; i < this.contactUs.phoneNumbers.length; i++) {
        const phNumLen = this.contactUs.phoneNumbers[i].includes('-') ? this.contactUs.phoneNumbers[i]
          .split('-')[1].length : this.contactUs.phoneNumbers[i]
          .includes(' ') ? this.contactUs.phoneNumbers[i]
          .split(' ')[1].length : this.contactUs.phoneNumbers[i].length;
        console.log('Phone Num Len :: ', phNumLen);
        // if (this.contactUs.phoneNumbers[i].length > 0 && !this.contactUs.phoneNumbers[i].match('[6-9]{2}[0-9]{8}')) {
        if (phNumLen < 8 || !this.contactUs.phoneNumbers[i].match('^([0-9\\+\\-\\s]*)$')) {
          this.isError = true;
          this.errorMessage.push('Phone No. is not valid');
          this.phoneClass = 'form-control fieldWithErrors';
        }
      }
    }

    // if (this.contactUs.emails.length > 0) {
    //   for (var i = 0; i < 1; i++) {
    //     if (this.contactUs.emails[i].length == 0) {
    //       this.isError = true;
    //       this.errorMessage.push("Email can't be empty");
    //       this.emailClass = "form-control fieldWithErrors";
    //     }
    //   }
    // }
    if (this.contactUs.emails.length > 0) {
      for (i = 0; i < this.contactUs.emails.length; i++) {
        if (this.contactUs.emails[i].length > 0 && !this.contactUs.emails[i].match(emailRex)) {
          this.isError = true;
          this.errorMessage.push('Emails is not valid');
          this.emailClass = 'form-control fieldWithErrors';
        }
      }
    }
  }

  clearClasses() {
    this.infoTopClass = 'form-control';
    this.nameClass = 'form-control';
    this.infoBottomClass = 'form-control';
    this.emailClass = 'form-control';
    this.phoneClass = 'form-control';
    this.aboutClass = 'form-control';
  }

  add() {
    this.disableButton = false;
    if (this.contactUs.emails.length > 0) {
      for (var i = 0; i < this.contactUs.emails.length; i++) {
        if (this.contactUs.emails[i].length == 0) {
          this.contactUs.emails = this.contactUs.emails.filter((val, k) => k != i);
          this.classArray = this.classArray.filter((val, k) => k != i);
        }
      }
    }
    if (this.contactUs.phoneNumbers.length > 0) {
      for (var i = 0; i < this.contactUs.phoneNumbers.length; i++) {
        if (this.contactUs.phoneNumbers[i].length == 0) {
          this.contactUs.phoneNumbers = this.contactUs.phoneNumbers.filter((val, k) => k != i);
          this.classArray = this.classArray.filter((val, k) => k != i);
        }
      }
    }
    if (this.contactUs.addresses.length > 0) {
      for (var i = 0; i < this.contactUs.addresses.length; i++) {
        if (this.contactUs.addresses[i].length == 0) {
          this.contactUs.addresses = this.contactUs.addresses.filter((val, k) => k != i);
          this.classArray = this.classArray.filter((val, k) => k != i);
        }
      }
    }
    this.contactUs.position = this.contactList.length;
    let contactUs = this.contactUs;
    let contactkey = this.contactUsService.addContact(this.eventId, contactUs);
    if (contactkey) {
      this.message = 'Added Successfully';
      setTimeout(function () {
        this.message = null;
        this.disableButton = true;
        this.router.navigate([Constants.CONTACT_US_FORM, this.eventId]);
      }.bind(this), 2000);
    }
  }

  update() {
    this.disableButton = false;
    if (this.contactUs.emails.length > 0) {
      for (var i = 0; i < this.contactUs.emails.length; i++) {
        if (this.contactUs.emails[i].length == 0) {
          this.contactUs.emails = this.contactUs.emails.filter((val, k) => k != i);
          this.classArray = this.classArray.filter((val, k) => k != i);
        }
      }
    }
    if (this.contactUs.phoneNumbers.length > 0) {
      for (var i = 0; i < this.contactUs.phoneNumbers.length; i++) {
        if (this.contactUs.phoneNumbers[i].length == 0) {
          this.contactUs.phoneNumbers = this.contactUs.phoneNumbers.filter((val, k) => k != i);
          this.classArray = this.classArray.filter((val, k) => k != i);
        }
      }
    }
    if (this.contactUs.addresses.length > 0) {
      for (var i = 0; i < this.contactUs.addresses.length; i++) {
        if (this.contactUs.addresses[i].length == 0) {
          this.contactUs.addresses = this.contactUs.addresses.filter((val, k) => k != i);
          this.classArray = this.classArray.filter((val, k) => k != i);
        }
      }
    }
    let contactUs = this.contactUs;
    this.contactUsService.updateContact(this.eventId, this.contactId, contactUs).then(res => {
      this.message = 'Updated Successfully';
    }).catch(error => {
      this.disableButton = true;
      this.errorMessage = error.message;
    });
    setTimeout(function () {
      this.message = null;
      this.disableButton = true;
      this.router.navigate([Constants.CONTACT_US_FORM, this.eventId]);
    }.bind(this), 2000);
  }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/contact-us-add/contact-us-add.component.ts